// Get API base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.weotp.com/api';

//Dev
//http://localhost:5010/api
//Prod
//https://www.weotp.com/api

// Get base URL without /api for serving static files
export const API_BASE_URL_WITHOUT_API = API_BASE_URL.replace('/api', '');

export default API_BASE_URL;

